export function CheckColumns(expected: string[], given: string[]): string[][] {
    
    if(!expected || !given || !Array.isArray(expected) || !Array.isArray(given))
     return []

    const valid = expected.reduce(
        (state, curr) => {
            if (given.includes(curr)) {
                state.validWithMatch.push([curr, curr])
            } else {
                state.validWithoutMatch.push([curr, ''])
            }
            return state
        },
        { validWithMatch: [], validWithoutMatch: [] }
    )
    given
    .filter( header => !expected.includes(header))
    .filter(header => !!header)
    .forEach(header => valid.validWithoutMatch.push(['',header]))


    return valid.validWithoutMatch.concat(valid.validWithMatch)
}
